export enum ProjectDataField {
    companyId           = "companyId",
    name                = "name",
    description         = "description",
    descriptionRtf      = "descriptionRtf",
    health              = "health",
    statusComments      = "statusComments",
    parentId            = "parentId",
    statusId            = "statusId",
    systemStatus        = "systemStatus",
    localTemplateId     = "localTemplateId",
    crmAccountId        = "crmAccountId",
    systemType          = "systemType",
    priority            = "priority",
    deadline            = "deadline",
    startDate           = "startDate",
    endDate             = "endDate",
    progress            = "progress",
    estimate            = "estimate",
    dateCreated         = "dateCreated",
    customFieldsData    = "customFieldsData",
    customFields        = "customFields",
    users               = "users",
    tasksTotal          = "tasksTotal",
    tasksOpen           = "tasksOpen",
    timeReports         = "timeReports",
    tasks               = "tasks",
    expenses            = "expenses",
    ownerUserId         = "ownerUserId",
    
    predecessors        = 'predecessors',
    successors          = 'successors',

    // ON-DEMAND: the backend selects it only when asked for by name, so request
    // it only where the Related Items block is actually rendered -- never from a
    // default project load. See AppProjectInfo.
    relatedItems        = 'relatedItems',
}